import { render, staticRenderFns } from "./Front.vue?vue&type=template&id=40e8890c&scoped=true&"
import script from "./Front.vue?vue&type=script&lang=js&"
export * from "./Front.vue?vue&type=script&lang=js&"
import style0 from "./Front.vue?vue&type=style&index=0&id=40e8890c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8890c",
  null
  
)

export default component.exports